const decorationContainer = (asStandAlonePage) => {
    return {
        backgroundColor: asStandAlonePage ? '#FFFFFF' : '#E4EEEF',
        display: 'flex',
        flexDirection: 'column',
        width: asStandAlonePage ? '100%' : '50%',
        justifyContent: 'start',
        alignItems: 'center',
        minHeight: '40vh',
        mt: {
            mobile: 0,
        },
        padding: {
            mobile: '0 24px',
            desktop: asStandAlonePage ? '40px 0 0' : '10vh 0 0',
        },
        mb: asStandAlonePage ? '50px' : '0',
    };
};
const ctaWrapper = (isDesktop, isTablet) => {
    return {
        mb: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        mt: { desktop: '2rem' },
        width: isTablet ? '40%' : !isDesktop ? '100%' : '18%',
    };
};
const skipLink = {
    textAlign: 'center',
    mt: { mobile: 3, desktop: 1 },
    cursor: 'pointer',
};
export default {
    decorationContainer,
    skipLink,
    ctaWrapper,
};
